import { render } from "./1.vue?vue&type=template&id=044ea568"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
script.render = render

export default script